'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 72px;\n  height: 72px;\n  color: white;\n  .fb-spinner-animation-base {\n    animation: ", " 1700ms infinite;\n    animation-fill-mode: backwards;\n    animation-direction: alternate;\n  }\n  .fb-spinner-line2 {\n    animation-delay: 0.1s;\n  }\n  .fb-spinner-line3 {\n    animation-delay: 0.2s;\n  }\n  .fb-spinner-line4 {\n    animation-delay: 0.3s;\n  }\n  .fb-spinner-b {\n    animation-delay: 0.4s;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: fixed !important; /* Ignore parent constraints */\n  inset: 0; /* Covers entire viewport */\n  z-index: 99999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.8);\n  width: 100vw;\n  height: 100vh;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n  70% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-spin-dot {\n    width: 48px;\n    height: 48px;\n    i {\n      background-color: white;\n      width: 21px;\n      height: 21px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _antd = require('antd');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AntSpinner = (0, _styledComponents2.default)(_antd.Spin)(_templateObject());

var linesKeyframe = _styledComponents.keyframes(_templateObject2());

var WrapSpinner = _styledComponents2.default.div(_templateObject3());

var Spinner = _styledComponents2.default.svg(_templateObject4(), linesKeyframe);

exports.default = {
  WrapSpinner: WrapSpinner,
  Spinner: Spinner,
  AntSpinner: AntSpinner
};